import React from 'react'
import { IconButton } from '@livechat/ui-kit'
import ChatIcon from './ChatIcon';
import { getTranslatedMessage } from '../utils/translations';

const styles = {
	root: {
		right: 25,
		zIndex: 2,
		bottom: 25,
		color: 'white',
		display: 'flex',
		cursor: "pointer",
		alignItems: 'center',
		position: 'absolute',
		willChange: 'opacity',
		WebkitBoxAlign: 'center',
		justifyContent: "space-between",
		background: 'transperant',
		borderRadius: '50px',
		boxShadow: 'rgba(0, 0, 0, 0.3) 0px 0px 1.2em',
	},
	img:{
		width:"80px",
		height:"80px"
	}
}

const Minimized = ({ maximize }) => (
	<div
		id="minimizedChat"
		onClick={maximize}
		style={styles.root}
	>
		<div><img src="https://botbuilder.labiba.ai/images/zainicon.png" style={styles.img}/></div>
	</div>
)

export default Minimized



// WEBPACK FOOTER //
// ./src/components/Minimized.js